<div class="d-flex flex-column">
    <button (click)="openModal()" class="btn btn-primary">
        {{'assignments.participants.skills.openModal' | transloco}}
    </button>
</div>
